/* The Brilian — sade ve doğru 3 Al 2 Öde sepet göstergesi. */
(function () {
  var TARGET = 3;
  var GIFT_VARIANT_ID = 44681126805570;

  function eligibleCount(cart) {
    return (cart.items || []).reduce(function (total, item) {
      var properties = item.properties || {};
      if (Number(item.variant_id) === GIFT_VARIANT_ID || properties._brilian_launch_gift === 'true') return total;
      if (item.vendor && item.vendor !== 'The Brilian') return total;
      if (Number(item.original_price || item.price || 0) <= 0) return total;
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function state(cart) {
    var count = eligibleCount(cart);
    if (count <= 0) return { hide: true };

    var remainder = count % TARGET;
    var freeCount = Math.floor(count / TARGET);

    if (remainder === 0) {
      return {
        hide: false,
        done: true,
        pct: 100,
        count: count + '/' + count,
        label: freeCount > 1 ? freeCount + ' ürün bizden' : '3 Al 2 Öde uygulandı'
      };
    }

    var need = TARGET - remainder;
    var nextTarget = count + need;
    return {
      hide: false,
      done: false,
      pct: Math.round((remainder / TARGET) * 100),
      count: count + '/' + nextTarget,
      label: need + ' ürün daha ekle · ' + (freeCount ? 'yeni bir ürün bizden' : '3. ürün ücretsiz')
    };
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'br-cartbar';
    el.setAttribute('data-br-cartbar', '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<div class="br-cartbar__row"><span class="br-cartbar__label"></span><span class="br-cartbar__count"></span></div><div class="br-cartbar__track"><span class="br-cartbar__fill"></span></div>';
    return el;
  }

  function render(bar, currentState) {
    bar.classList.toggle('is-hidden', !!currentState.hide);
    if (currentState.hide) return;
    bar.classList.toggle('is-done', !!currentState.done);
    bar.querySelector('.br-cartbar__label').textContent = currentState.label;
    bar.querySelector('.br-cartbar__count').textContent = currentState.count;
    bar.querySelector('.br-cartbar__fill').style.width = currentState.pct + '%';
  }

  function hosts() {
    var list = [];
    var inner = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('cart-drawer .drawer__inner');
    if (inner) list.push({ inner: inner, before: inner.querySelector('cart-drawer-items') || inner.querySelector('.cart-drawer__form') });
    var pageItems = document.querySelector('#main-cart-items');
    if (pageItems && pageItems.parentNode) list.push({ inner: pageItems.parentNode, before: pageItems });
    return list;
  }

  function place(currentState) {
    hosts().forEach(function (host) {
      var bar = host.inner.querySelector(':scope > [data-br-cartbar]');
      if (!bar) {
        bar = build();
        if (host.before && host.before.parentNode === host.inner) host.inner.insertBefore(bar, host.before);
        else host.inner.insertBefore(bar, host.inner.firstChild);
      }
      render(bar, currentState);
    });
  }

  var busy = false;
  var again = false;

  function refresh() {
    if (busy) {
      again = true;
      return;
    }

    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { place(state(cart)); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          refresh();
        }
      });
  }

  function observe(node) {
    if (!node || !window.MutationObserver) return;
    var timer = null;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target && target.closest && target.closest('[data-br-cartbar]')) continue;
        clearTimeout(timer);
        timer = setTimeout(refresh, 180);
        return;
      }
    });
    observer.observe(node, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    observe(document.getElementById('CartDrawer') || document.querySelector('cart-drawer'));
    var page = document.getElementById('main-cart-items');
    if (page) observe(page);
    document.addEventListener('shopify:section:load', refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();